import { combineReducers } from "redux"

import listByCourseIdReducer from "./list/reducer"

export const lessonsStateReducer = combineReducers({
  byCourseId: listByCourseIdReducer,
})
export { default as lessonEntitiesReducer } from "./entities/reducer"
